import { gql } from '@apollo/client';

export default gql`
  mutation DeleteProductNutritionalInfoImageMutation(
    $nutritionalInfoImageId: Int!
  ) {
    deleteProductNutritionalInfoImageById(
      input: { id: $nutritionalInfoImageId }
    ) {
      productNutritionalInfoImage {
        id
      }
    }
  }
`;
